/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useRef } from "react";

/**
 * A hook that performs component did update
 * @param callback to run after first render
 * @param deps
 */
function useComponentDidUpdateEffect(callback: () => void, deps: React.DependencyList): void {
    const didMount = useRef(false);

    useEffect(() => {
        if (didMount.current) {
            callback();
        }
        else {
            didMount.current = true;
        }
    }, deps);
}

export default useComponentDidUpdateEffect;
